<div class="flex flex-column pb-0">
    <div class="grid">
        <div class="col-12">
            <p>We linked the best priced deal on the Google Flights & Skyscanner links below, but you can explore alternative date options in the Google calendar view</p>
        </div>
        <div class="col-12 flex gap-2 align-items-center">
            <i class="ph ph-calendar text-2xl"></i>
            <p>Dates: {{itineraryDates}}</p>

        </div>
        <div class="col-12 md:col-6">
            <p-button
                label="Book on Google"
                severity="info"
                [outlined]="true"
                styleClass="w-full p-2 border-1 border-round border-300 text-left flex-1"
                (click)="openGoogle()"
            >
                <img src="assets/images/featured-logos/google-flight.svg" height="34" class="ml-2" />
                <p-divider layout="vertical" styleClass="mr-4 my-0 h-2rem" />
            </p-button>
        </div>
        <div class="col-12 md:col-6">
            <p-button
                label="Book on Skyscanner"
                severity="info"
                [outlined]="true"
                styleClass="w-full p-2 border-1 border-round border-300 text-left flex-1"
                (click)="openSkyScanner()"
            >
                <img src="assets/images/featured-logos/skyscanner.svg" height="34" class="ml-2"/>
                <p-divider layout="vertical" styleClass="mr-4 my-0 h-2rem"/>
            </p-button>
        </div>
        <!-- <div class="col-12 py-0">
         <p-divider />
        </div>
        <div class="col-12">
            <div
                class="border-1 border-round border-300 w-full flex flex-row align-items-center p-2 cursor-pointer"
                (click)="
                openModal(
                    dialogService,
                    PriceTrackingModalComponent
                )
            "
            >
            <i class="ph-thin ph-shield-check text-6xl text-green-500 pl-4 pr-3"></i>
                <p-divider layout="vertical" />

                <div class="flex flex-column">
                    <p class="font-bold m-0">Did you book this deal?</p>
                    <p class="font-normal text-secondary">Let us know, and we'll track price drops for even more savings.</p>
                </div>

                <div class="ml-auto">
                    <i class="ph ph-caret-right text-2xl font-bold"></i>
                </div>
            </div>
        </div> -->
    </div>
</div>
